import {
  ADDRESS_BOOK_FETCH_STARTED,
  ADDRESS_BOOK_FETCH_SUCCEEDED,
  ADDRESS_BOOK_FETCH_FAILED,
  ADDRESS_BOOK_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  addressbook: {},
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ADDRESS_BOOK_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case ADDRESS_BOOK_FETCH_SUCCEEDED:
      const { project = {} } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        addressbook: {
          ...action.payload,
          project: {
            ...project,
            value: project?.id,
            label: project?.title
          }
        }
      };
    case ADDRESS_BOOK_FETCH_FAILED:
      return { ...state, status: statuses.failed, addressbook: {}, error: action.error };
    case ADDRESS_BOOK_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
